module.exports = __webpack_public_path__ + "img/217d92e.jpg";